<template>
    <div>
        <Header />
        <main class="app-content">
            <div class="app-title">
                <div>
                    <h1><i class="fa fa-dashboard"></i>ÇEK TAKİP DETAY EKRANI</h1>
                </div>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
                    <li class="breadcrumb-item"><a href="#">ÇEK TAKİP DETAY EKRANI</a></li>
                </ul>
            </div>
            <br>


            <br>
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <form>
                        <div class="form-group">
                            <label class="control-label">FİRMA ADI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.firmaname }}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">ÇEK AÇIKLAMASI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.content }}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">DEVAMINA YAZILAN ÇEK TOPLAM TUTARI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.toplamcekodemesi }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-4 col-md-4">
                    <form>
                        <div class="form-group">
                            <label class="control-label">ÇEK TUTARI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.tutar }}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">ÇEK SERİ NO:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.serino }}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">TOPLAM YAZILAN ÇEK SAYISI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.toplamcek }}</div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-4 col-md-4">
                    <form>
                        <div class="form-group">
                            <label class="control-label">VADE TARİHİ:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.vade }}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">ÇEKİN YAZILDIĞI BANKA:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.banka }}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">KALAN YAZILABİLECEK ÇEK MİKTARI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ maincheck.kalancek }}</div>
                        </div>
                    </form>
                </div>
            </div>
            <div style="border: 1px solid;position:absolute;">
                <button @click="cekonayla()" class="btn btn-success" type="button">
                    ÇEK TAHSİLİNİ ONAYLA
                </button>
            </div>
            <br>
            <br>
            <br>
            <div class="row">
                <div class="col-md-12">
                    <div class="tile">
                        <div class="tile-body">
                            <table class="table table-hover table-bordered" id="sampleTable">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Firma Adı</th>
                                        <th>Tutar</th>
                                        <th>Vade</th>
                                        <th>Açıklama</th>
                                        <th>Banka</th>
                                        <th>Seri No</th>
                                        <th>Kayıt Tarihi</th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <Sidebar />
    </div>
</template>
<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import { debounce } from "lodash";
import { result } from "lodash";
export default {
    data() {
        return {
            searchString: "",
            results: [],
            maincheck: [],
            product: [],
            maincontent: [],
            id: this.$route.query.idm,
            result: {
                id: "",
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                tc_number: "",
                imgSrc: "",
                imgUrl: "",
            },
            file: "",
            fileWarn: "",
        };
    },
    watch: {
        searchString: debounce(function () {
            this.search();
        }, 250),
        $route() {
            $("#navbarSupportedContent").collapse("hide");
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        var token = localStorage.getItem("token");
        if (!token) {
            this.$router.push("/");
        }
        var results = this.result;
        let datas = {
            id: this.id
        };

        let url = store.state.base_url + "Cek/getAllSubChecks.php?key=123";
        var datas2 = {
            id: localStorage.getItem("id"),
            token: localStorage.getItem("token"),
            checkId: this.id,
        };

        axios
            .post(url, JSON.stringify(datas2))
            .then((response) => {
                datas2 = response.data.data;
                this.maincheck = response.data.main;
                var table = $("#sampleTable").DataTable(
                    {
                        pageLength: 20,
                        order: [[0, 'desc']]
                    });
                $.each(datas2, function (index, value) {
                    table.row
                        .add([
                            value["id"],
                            value["firmaname"],
                            new Intl.NumberFormat('tr-TR', {
                                style: 'currency',
                                currency: 'TRY'
                            }).format(value["tutar"]),
                           
                            value["vade"],
                            value["content"],
                            value["banka"],
                            value["serino"],
                            value["regdate"],
                        ])
                        .draw(false);
                });

                $("#sampleTable tbody").on("click", "tr", function () {
                    var data = table.row(this).data();
                    results.id = data[0];
                    window.location.href = "#/updateCheck?id=" + results.id;
                });
            })
            .catch((err) => {
                //console.log(err.response);
            });
    },

    methods: {
        routeDetail: function (item) {
            window.location.href = "#/updateCheck?id=" + item.id;
        },
        cekonayla: function () {
            var dataStatus = {
                id: localStorage.getItem("id"),
                token: localStorage.getItem("token"),
                cekid: this.id,
            };
            let dataUrl3 =
                store.state.base_url + "Cek/cekStatusOne.php?key=123";
            axios.post(dataUrl3, JSON.stringify(dataStatus)).then((response) => {
                if (response.data == true) {
                    this.$swal({
                        text: "ÇEK TAHSİLİ ONAYLANDI",
                        icon: "success",
                        closeOnClickOutside: false,
                    });
                }
            });
        },
        goProducts: function () {
            console.log("deneme");
            this.router.navigate(["/staff_detail"], {
                queryParams: { new_id: this.result.id },
            });
            console.log(this.results.id);
        },
        async getFilteredUsers() {
            const filteredUsers = await fetch(
                ' https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/getAllGider.php'
            );
            this.users = await filteredUsers.json();
        },
        search: function () {
            if (this.searchString.length > 0) {
                axios
                    .get(
                        `https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/searchRapor.php?key=123&keyword=${this.searchString}`
                    )
                    .then((response) => {
                        var deger = response.data.length;
                        if (deger > 50) {
                            this.results = response.data.slice(0, 50);
                        } else {
                            this.results = response.data;
                        }
                    });
            } else {
                this.results = null;
            }
        },
    },

    components: {
        Header,
        Sidebar,
    },
};
</script>
<style>
.searchCss {
    border-radius: 6px;
    background-color: rgb(215, 98, 98);
}
</style>


// WEBPACK FOOTER //
// src/components/ChecksMain.vue